import React from "react";
import { useApp } from "../../contexts/AppContext";
import { useAuth } from "../../contexts/AuthContext";
import { TEMARIO } from "../../constants/temario";
import { siteConfig } from "../../config/siteConfig";

const StatsCards = () => {
  const { user, calculateOverallProgress } = useApp();
  const { profile, isLoadingProfile } = useAuth();
  const { uiCopy } = siteConfig;
  const labels = uiCopy.statsCards;
  const totalTopics = TEMARIO.length;

  const stats = [
    {
      title: labels.generalProgress,
      value: `${calculateOverallProgress()}%`,
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
        </svg>
      ),
      color: "text-blue-500",
    },
    {
      title: labels.sectionsRead,
      value: `${profile?.read_laws?.length || 0}/${totalTopics}`,
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 4.804A7.903 7.903 0 0111 5c.448 0 .891.037 1.32.108V17a7.99 7.99 0 00-1.12-.082c-1.135 0-2.26.173-3.32.512v-12.63A7.906 7.906 0 019 4.804z" />
        </svg>
      ),
      color: "text-emerald-500",
    },
    {
      title: labels.examsTaken,
      value: profile?.exam_count || 0,
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
      ),
      color: "text-amber-500",
    },
    {
      title: labels.bestScore,
      value: `${profile?.best_score || 0}%`,
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ),
      color: "text-rose-500",
    },
  ];

  return (
    <div className="grid md:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div key={index} className="bg-white p-6 rounded-[2rem] card-shadow border border-slate-100">
          <p className={`text-[10px] font-black ${stat.color} uppercase tracking-[0.2em] mb-3`}>
            {stat.title}
          </p>
          <div className="flex items-end justify-between">
            <h4 className="text-3xl font-black">{stat.value}</h4>
            <div className="text-slate-400 mb-1">{stat.icon}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
